module.exports = __webpack_public_path__ + "img/atari1200_page18.1b0608fc.jpg";